import React, { useState } from 'react';
import integrationService from '../../services/api/integrationService';

export const financialPermissions = [
  ['financial:salary:read', 'Read salary terms'], ['financial:salary:write', 'Publish salary terms'],
  ['financial:billing:read', 'Read billing terms'], ['financial:billing:write', 'Publish billing terms'],
];
export const parseFinancialAccess = (sourceSystems, employerCvrs) => ({
  sourceSystems: sourceSystems.split(/[,\s]+/).map((value) => value.trim()).filter(Boolean),
  employerCvrs: employerCvrs.split(/[,\s]+/).map((value) => value.trim()).filter(Boolean),
});
export const FinancialAccessFields = ({ prefix, sources, employers, setSources, setEmployers, disabled }) => (
  <div style={{ display: 'grid', gap: '.5rem', margin: '.7rem 0' }}>
    <label htmlFor={`${prefix}-sources`}>Allowed source systems (comma separated)
      <input id={`${prefix}-sources`} value={sources} onChange={(e) => setSources(e.target.value)} disabled={disabled} placeholder="vikarcrm" />
    </label>
    <label htmlFor={`${prefix}-employers`}>Allowed payroll employer CVRs (comma separated)
      <input id={`${prefix}-employers`} value={employers} onChange={(e) => setEmployers(e.target.value)} disabled={disabled} />
    </label>
    <small>Choose the legal payroll employers this key may access. Customer CVRs do not grant payroll access.</small>
  </div>
);

export default function FinancialAccessEditor({ client, onSaved }) {
  const [open, setOpen] = useState(false);
  const [scopes, setScopes] = useState([]);
  const [sources, setSources] = useState('');
  const [employers, setEmployers] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const show = () => {
    setScopes((client.scopes || []).filter((scope) => scope.startsWith('financial:')));
    setSources((client.financialAccess?.sourceSystems || []).join(', '));
    setEmployers((client.financialAccess?.employerCvrs || []).join(', '));
    setError(''); setOpen(true);
  };
  const save = async () => {
    setBusy(true); setError('');
    try {
      await integrationService.updateFinancialAccess(client.id, { financialScopes: scopes,
        financialAccess: scopes.length ? parseFinancialAccess(sources, employers) : null,
        expectedUpdatedAt: client.updatedAt });
      await onSaved(); setOpen(false);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  if (!open) return <button type="button" onClick={show}>Financial access</button>;
  return <fieldset style={{ minWidth: 240 }}>
    <legend>Financial access — {client.name}</legend>
    {financialPermissions.map(([value, label]) => <label key={value} style={{ display: 'block' }}>
      <input type="checkbox" disabled={busy} checked={scopes.includes(value)}
        onChange={(e) => setScopes((old) => e.target.checked ? [...old, value] : old.filter((scope) => scope !== value))} /> {label}
    </label>)}
    <FinancialAccessFields prefix={`financial-${client.id}`} sources={sources} employers={employers}
      setSources={setSources} setEmployers={setEmployers} disabled={busy} />
    {error && <p role="alert">{error}</p>}
    <button type="button" disabled={busy} onClick={save}>Save financial access</button>{' '}
    <button type="button" disabled={busy} onClick={() => setOpen(false)}>Cancel</button>
  </fieldset>;
}
